import React from 'react';
import Icon from '~/UI/Icon/Icon';
import { TailwindTooltip } from '../TailwindTooltip/TailwindTooltip';

export enum ProductItemStatus {
	OK = 'ok',
	BEFORE_VALIDITY = 'before-validity',
	AFTER_VALIDITY = 'after-validity',
	MISSING_PRICES = 'missing-prices',
	ALTERNATIVE_DATASOURCE = 'alternative-datasource',
	OTHER_DATASOURCE = 'other-datasource',
	MISSING_IN_DATASET = 'missing-in-dataset',
}

function renderIcon(iconName: string) {
	return <Icon name={iconName} />;
}

function resolveStatusSeverity(status: string) {
	if (
		status === ProductItemStatus.ALTERNATIVE_DATASOURCE ||
		status === ProductItemStatus.MISSING_IN_DATASET ||
		status === ProductItemStatus.MISSING_PRICES
	) {
		return 5;
	}
	if (status === ProductItemStatus.AFTER_VALIDITY) {
		return 4;
	}
	if (status === ProductItemStatus.BEFORE_VALIDITY) {
		return 1;
	}
	return 0;
}

function renderStatusText(status: string) {
	if (status === ProductItemStatus.BEFORE_VALIDITY) {
		return 'For the selected Reference date, the validity of the product has not started yet and it might not be suitable for referencing. Please check product details.';
	}
	if (status === ProductItemStatus.AFTER_VALIDITY) {
		return "For the selected Reference date, the product validity has ended and it shouldn't be used for referencing. Please check product details.";
	}
	if (status === ProductItemStatus.MISSING_PRICES) {
		return "For the selected Reference date, the product doesn't contain prices suitable for referencing";
	}
	if (status === ProductItemStatus.ALTERNATIVE_DATASOURCE) {
		return 'DataSource of this product is not officially recognized and might not be suitable for price referencing.';
	}
	if (status === ProductItemStatus.MISSING_IN_DATASET) {
		return "For the selected Reference date, the product wasn't present in the corresponding dataset";
	}
	return null;
}

interface Props {
	status: string;
}

const IconNames = [null, 'green-clock', 'yellow-question-mark', 'orange-clock', 'red-clock', 'red-exclamation-mark'];

export function ProductStatusIcon({ status }: Props) {
	const statusSeverity = resolveStatusSeverity(status);
	const statusText = renderStatusText(status);
	const iconName = IconNames[Math.max(statusSeverity)] ?? null;
	if (iconName === null) {
		return null;
	}
	const icon = renderIcon(iconName);

	return (
		<TailwindTooltip
			reference={
				<>
					{icon}
					<span className='absolute right-full top-0 -mr-1 -mt-1 w-3 h-3 leading-3 rounded-full text-[11px] font-semibold bg-white text-center'>
						?
					</span>
				</>
			}
			displayClass='inline-block mr-2 h-4 align-middle'
			position='left'
		>
			{statusText}
		</TailwindTooltip>
	);
}
